import React, { useState } from "react";
import PropTypes from "prop-types";
import GridViewActionImage from "assets/images/general/grid-view-action.svg";
import { useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { getUserRole } from "recoil/Auth";
import OutsideClickHandler from "react-outside-click-handler";
import moment from "moment";
import EditIcon from "assets/images/form/edit-icon.svg";
import DeactivateIcon from "assets/images/form/deactivate-icon.svg";
import ActivateIcon from "assets/images/form/activate-icon.png";
import DetailIcon from "assets/images/form/detail-view.svg";
import ButtonComponent from "components/ButtonComponent";
function ScheduleActions({ data, props, viewType }) {
  const now = moment();
  const scheduleTime = moment.unix(data.schedule_date);
  const thirtyMinutesBefore = scheduleTime.clone().subtract(30, "minutes");
  const thirtyMinutesAfter = scheduleTime.clone().add(30, "minutes");
  const showStartClass = now.isBetween(thirtyMinutesBefore, thirtyMinutesAfter);
  const userRole = useRecoilValue(getUserRole);
  const navigate = useNavigate();
  const [showMenu, setShowMenu] = useState(false);
  const editSchedule = () => {
    if (data.is_active)
      navigate("/edit_schedule", { state: { update_id: data.id } });
    else props.actionOnDeactivatedSchedule();
  };
  const viewScheduleDetail = () => {
    if (data.is_active)
      navigate("/schedule_detail", { state: { record_id: data.id } });
    else props.actionOnDeactivatedSchedule();
  };
  const deactivateSchedule = async () => {
    props.deactivateScheduleConfirmation(data.id, data.is_active);
  };
  const viewAttendance = () => {
    navigate("/view_attendance", {
      state: { meeting_id: data.zoom_meeting_id },
    });
  };
  const trackStudents = () => {
    navigate("/track_students", {
      state: { meeting_id: data.zoom_meeting_id },
    });
  };

  return (
    // <div className="d-flex gap-3 table-actions">
    //   <OutsideClickHandler
    //     onOutsideClick={() => {
    //       setShowMenu(false);
    //     }}
    //   >
    //     <div className="position-relative">
    //       {userRole !== "STUDENT" && (
    //         <img
    //           src={GridViewActionImage}
    //           alt="action"
    //           className="cursor-pointer"
    //           onClick={() => setShowMenu(!showMenu)}
    //         />
    //       )}
    //       {showMenu ? (
    //         <div className="actions-list">
    //           {userRole === "TEACHER" ? (
    //             <>
    //               {showStartClass && (
    //                 <span onClick={() => {}}>Start Class</span>
    //               )}
    //               <span onClick={viewAttendance}>View Attendance</span>
    //               <span onClick={trackStudents}>Track Student</span>
    //               <span onClick={viewScheduleDetail}>View Details</span>
    //             </>
    //           ) : userRole === "BUSINESS_ADMIN" ? (
    //             <>
    //               <span onClick={editSchedule}>Edit</span>
    //               {data.is_complete && (
    //                 <>
    //                   <span onClick={deactivateSchedule}>
    //                     {data.is_active ? "Deactivate" : "Activate"}
    //                   </span>
    //                   <span onClick={viewAttendance}>View Attendance</span>
    //                   <span onClick={trackStudents}>Track Student</span>
    //                   <span onClick={viewScheduleDetail}>View Details</span>
    //                 </>
    //               )}
    //             </>
    //           ) : (
    //             <></>
    //           )}
    //         </div>
    //       ) : (
    //         <></>
    //       )}
    //     </div>
    //   </OutsideClickHandler>
    // </div>

    <div className="d-flex gap-3 table-actions">
      {viewType === "grid" ? (
        <>
          <OutsideClickHandler
            onOutsideClick={() => {
              setShowMenu(false);
            }}
          >
            <div className="position-relative">
              <img
                src={GridViewActionImage}
                alt="action"
                className="cursor-pointer"
                onClick={() => setShowMenu(!showMenu)}
              />
              {showMenu ? (
                <div className="actions-list">
                  {userRole === "TEACHER" ? (
                    <>
                      {showStartClass && (
                        <span onClick={() => {}}>Start Class</span>
                      )}
                      <span onClick={viewAttendance}>View Attendance</span>
                      <span onClick={trackStudents}>Track Students</span>
                      <span onClick={viewScheduleDetail}>View Details</span>
                    </>
                  ) : userRole === "BUSINESS_ADMIN" ? (
                    <>
                      <span onClick={viewAttendance}>View Attendance</span>
                      <span onClick={viewScheduleDetail}>View Details</span>
                      <span onClick={editSchedule}>Edit</span>
                      <span onClick={deactivateSchedule}>
                        {data.is_active ? "Deactivate" : "Activate"}
                      </span>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              ) : (
                <></>
              )}
            </div>
          </OutsideClickHandler>
        </>
      ) : viewType === "list" ? (
        userRole === "TEACHER" ? (
          <>
            {showStartClass && (
              <ButtonComponent
                text="start_class"
                variant="white-blue-14 white-blue-14-rounded-border"
                onClick={null}
              />
            )}
            <ButtonComponent
              text="view_attendance"
              variant="white-crayola-1 white-crayola-1-rounded-border"
              onClick={viewAttendance}
            />
            <ButtonComponent
              text="track_student"
              variant="white-green-6 white-green-6-rounded-border"
              onClick={trackStudents}
            />
            <img
              onClick={viewScheduleDetail}
              src={DetailIcon}
              alt="edit-icon"
            />
          </>
        ) : userRole === "BUSINESS_ADMIN" ? (
          <>
            <ButtonComponent
              text="view_attendance"
              variant="white-crayola-1 white-crayola-1-rounded-border"
              onClick={viewAttendance}
            />
            <img
              onClick={viewScheduleDetail}
              src={DetailIcon}
              alt="edit-icon"
            />
            <img onClick={editSchedule} src={EditIcon} alt="edit-icon" />
            <img
              onClick={deactivateSchedule}
              src={data.is_active ? DeactivateIcon : ActivateIcon}
              alt="edit-icon"
              className="align-self-center"
            />
          </>
        ) : (
          <></>
        )
      ) : (
        <></>
      )}
    </div>
  );
}
ScheduleActions.propTypes = {
  data: PropTypes.object.isRequired,
  props: PropTypes.object.isRequired,
  viewType: PropTypes.string.isRequired,
};
export default ScheduleActions;
